module.exports = {"region":{"options":["South East","South West","Midlands","North","Scotland","Northern Ireland"]},"sector":{"options":["Advertising/Marketing/PR/Media","Engineering/Automotive","Goods/Services/Hospitality/Recreation","Labour/Agriculture/Farming","Finance & Law","IT/Telecoms","Medical"]},"companySize":{"options":["1 - 9 employees","10 - 49 employees","50 - 249 employees (SME)","250 - 1000 employees (mid)","1000+ employees (large)"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data.userinfo.employer.json
// module id = 40
// module chunks = 0